<div class="card-group">
    <app-album-card *ngFor="let album of albums.albumSummaries" [album]="album" [artist]="artist"></app-album-card>
</div>